import { registerBlockType } from "@wordpress/blocks";
import { Provider } from "react-redux";
import { Icon } from "@wordpress/components";
import store from "store";
import Editor from "./Edit";
import Save from "./Save";

registerBlockType("vino/account", {
	title: "Account",
	icon: {
		src: <Icon icon="products" />,
	},
	category: "corksy",
	keywords: ["corksy"],
	description: "Customer account.",
	supports: {
		align: ["wide", "full"],
		html: false,
		multiple: false,
	},
	edit: function (props) {
		return (
			<Provider store={store}>
				<Editor {...props} />
			</Provider>
		);
	},
	save: Save,
});
